import { render, staticRenderFns } from "./asternDialog.vue?vue&type=template&id=4faebfe1&"
import script from "./asternDialog.vue?vue&type=script&lang=js&"
export * from "./asternDialog.vue?vue&type=script&lang=js&"
import style0 from "./asternDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports